import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 132 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M65.6555 0.883728H55.793L43.5016 12.6675V0.951851H35.8193V30.6807H43.5016V22.4515L47.6242 18.5701L55.9996 30.6807H65.9826L53.6301 12.9279L65.6555 0.883728Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M99.8637 0.883728H90.0021L77.7097 12.6675V0.951851H70.0283V30.6807H77.7097V22.4515L81.8324 18.5701L90.2078 30.6807H100.191L87.8391 12.9279L99.8637 0.883728Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.709 23.296C9.53286 23.0027 8.62015 22.0896 8.3274 20.9108C7.48873 17.5296 7.48873 14.1027 8.3274 10.7215C8.62015 9.54353 9.53286 8.62946 10.709 8.33627C12.3967 7.91631 14.0964 7.7059 15.7962 7.7059C17.4958 7.7059 19.1947 7.91631 20.8823 8.33627C22.0602 8.62946 22.972 9.54353 23.2648 10.7215C24.1043 14.1027 24.1043 17.5296 23.2648 20.9108C22.972 22.0896 22.0602 23.0027 20.8823 23.296C17.5079 24.1368 14.0844 24.1368 10.709 23.296ZM22.7396 0.857266C18.1511 -0.286187 13.4411 -0.285324 8.85349 0.857266C4.90387 1.84032 1.84027 4.90763 0.85954 8.86315C-0.286513 13.4767 -0.286513 18.1556 0.85954 22.7699C1.84027 26.7255 4.90387 29.7919 8.85349 30.7759C11.1473 31.3467 13.4834 31.6365 15.7962 31.6365C18.1089 31.6365 20.4457 31.3467 22.7396 30.7759C26.6892 29.7919 29.7511 26.7255 30.7335 22.7699C31.8779 18.1556 31.8779 13.4767 30.7335 8.86315C29.7511 4.90763 26.6892 1.84032 22.7396 0.857266Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M122.785 20.9111C122.492 22.089 121.58 23.0031 120.403 23.2964C117.028 24.1363 113.605 24.1363 110.23 23.2964C109.053 23.0031 108.14 22.089 107.847 20.9111C107.009 17.5299 107.009 14.1021 107.847 10.7218C108.14 9.54301 109.053 8.6298 110.23 8.33661C111.917 7.91666 113.617 7.70624 115.316 7.70624C117.016 7.70624 118.715 7.91666 120.403 8.33661C121.58 8.6298 122.492 9.54301 122.785 10.7218C123.624 14.1021 123.624 17.5299 122.785 20.9111ZM130.253 8.86262C129.271 4.90712 126.209 1.84066 122.259 0.85674C117.672 -0.285849 112.962 -0.284986 108.373 0.85674C104.424 1.84066 101.361 4.90712 100.379 8.86262C99.2342 13.4769 99.2342 18.156 100.379 22.7694C101.361 26.7249 104.424 29.7923 108.373 30.7754C110.667 31.347 113.003 31.6369 115.316 31.6369C117.63 31.6369 119.966 31.347 122.259 30.7754C126.209 29.7923 129.271 26.7249 130.253 22.7694C131.399 18.156 131.399 13.4769 130.253 8.86262Z",
			fill: "currentColor"
		})
	]
});
export default SvgLogo;
